import { useQuery } from "@tanstack/react-query";
import { DocumentContentService } from "../../../../services/document/document-content.service";
import { usePublicDocumentInfo } from "../published-documents";

export const usePublishDocumentContent = () => {
  const { data: docInfo } = usePublicDocumentInfo();
  const fileId = docInfo?.fileId;

  const handleSelect = (res: any[]): any[] => {
    if (!res) return [];
    const maxVersion = Math.max(...res.map((o: any) => o.publishVersion));
    if (isNaN(maxVersion)) return res.filter((e: any) => !e.publishVersion);
    return res.filter((e: any) => e.publishVersion === maxVersion);
  };

  const { data, isLoading } = useQuery({
    queryKey: ["publish-document-content", fileId],
    queryFn: () => DocumentContentService.getList("", fileId),
    enabled: !!fileId,
    select: (res: any) => handleSelect(res),
  });

  return { data, isLoading };
};
